import { render } from "./TemplateMfittMyTicketPurchase.vue?vue&type=template&id=4bb2f9c6"
import script from "./TemplateMfittMyTicketPurchase.vue?vue&type=script&lang=js"
export * from "./TemplateMfittMyTicketPurchase.vue?vue&type=script&lang=js"

import "./TemplateMfittMyTicketPurchase.vue?vue&type=style&index=0&id=4bb2f9c6&lang=css"
script.render = render

export default script